import { t } from "@lingui/core/macro";
import { DateTime } from "luxon";
import { useSearchParams } from "react-router-dom";
import { z } from "zod";

const useDateRangeParams = () => {
  const [searchParams] = useSearchParams();
  const parsedParams = getSearchParamsSchema().safeParse(
    Object.fromEntries(searchParams),
  );

  if (parsedParams.success) {
    return parsedParams.data;
  }
};

const getSearchParamsSchema = () =>
  z.object({
    "date-from": z
      .string()
      .regex(/\d{4}-\d{2}-\d{2}/)
      .nullish()
      .transform((v) => v ?? undefined),
    "date-to": z
      .string()
      .regex(/\d{4}-\d{2}-\d{2}/)
      .refine((date) => DateTime.now() > DateTime.fromISO(date), {
        message: t`Datum ukončení musí nastat před dnešním dnem.`,
      }),
  });

type DateRangeParams = z.infer<ReturnType<typeof getSearchParamsSchema>>;

export { useDateRangeParams };
export type { DateRangeParams };
